/**
 * Entry point for the hosted script-tag bundle (`window.CaptelloSdk`).
 *
 * Bundles the core exports (protocol, client, embed-URL builder) together with
 * the promise helpers into a single global, for hosts that embed the webview
 * with a plain `<script src>` and no bundler.
 *
 * The React adapter is deliberately excluded: React hosts have a bundler and
 * should install `@captello/ulc-webview-sdk` from npm instead.
 */

export * from "./index";

export { waitForMessage, waitForFormLoad, submitForm, MessageTimeoutError } from "./promises";
export type { WaitOptions } from "./promises";

// The mobile-app channel, for hosts and embedded applications that load the SDK from a
// script tag rather than a bundler.
export {
    MobileHostClient,
    MobileHostRequestType,
    MobileHostResponseType,
    parseMobileHostRequest,
    parseMobileHostResponse,
    ScannerError,
} from "./mobile-host";
export { EmbeddedAppClient } from "./embedded-app";
export type {
    MobileHostRequest,
    MobileHostRequestMap,
    MobileHostResponse,
    MobileHostResponseMap,
    MobileHostResponseListener,
    MobileHostClientOptions,
    AuthTokenMessage,
    ScannedPerson,
    ScannerClosedMessage,
    ScannerResultMessage,
} from "./mobile-host";
export type { EmbeddedAppClientOptions, MobileHostRequestListener, AnyMobileHostRequestListener } from "./embedded-app";
